/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */

import '../App.css';
import logo from '../assets/header.png';
import Ticker from './ticker';
import $ from "jquery";
import About from '../components/about';
import Buy from '../components/buy';
import up from '../assets/arrow-up.png';
import Footer from '../components/footer';
import navbar from '../assets/navigation-bar.png';
import wrong from '../assets/wrong.png';
import doggy from '../assets/dog.png';
import name from '../assets/name.png';
import twitter from '../assets/x.png';
import tg from '../assets/tg.png';
import discord from '../assets/discord.png';
import airdrop from '../assets/airdrop.png';
import arrow from '../assets/arrow.png';

import React, { useEffect, useMemo, useState } from 'react';
import { Web3Button, Web3Modal, useWeb3Modal } from '@web3modal/react';
import { mainnet, useAccount, useContractRead, useContractReads, useContractWrite, useNetwork, usePublicClient, useSwitchNetwork } from 'wagmi';
import { createPublicClient, formatEther, http, parseEther } from 'viem';
import Exchanges from '../components/exchanges';
import Tokenomics from '../components/tokenomics';

var Scroll = require('react-scroll');

var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;


const stakeLink = () => {
	window.open("#");
}

$(window).on('load', function () {
	setTimeout(function () { // allowing 3 secs to fade out loader
		$('.page-loader').fadeOut('slow');
	}, 2500);
});

const tweet = () => {
    window.open("https://x.com/anago_monad_xyz/");
}

const Home = () => {

	const [_navbarOpen, set_navbarOpen] = useState(0);
	const [showButton, setShowButton] = useState(false);



	async function closeNav() {
		set_navbarOpen(0);
		//this.setState({ _navbarOpen: 0 });
	}

	async function navbarOpen() {
		set_navbarOpen(1);
		//this.setState({ _navbarOpen: 0 });
	}

	useEffect(() => {
		function handleScroll() {
			if (window.scrollY > window.innerHeight) {
				setShowButton(true);
			} else {
				setShowButton(false);
			}
		}

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (

		<div class="allWrap">
			<div class="light">

				{/*<div class="page-loader">
					<div class="parent-container">
						<div class="loader"></div>
						<div class="loadTxt">LOADING</div>
					</div>
				</div>*/}

				{/*<Element name="up">
					<div class="headers">

						<div class="headers2">

							<div class="logo"><img class="logoPic" src={logo} /></div>

							<div class="right">

								<div class="connect">
									<div ><Link activeClass="" id="fontSize" to="exchanges" spy={true} smooth={true} duration={550}>EXCHANGES</Link></div>
									<div ><Link activeClass="" id="fontSize" to="utils" spy={true} smooth={true} duration={550}>UTILITIES</Link></div>
									<div ><Link activeClass="" id="fontSize" to="buy" spy={true} smooth={true} duration={550}>HOW TO BUY</Link></div>
									<div ><Link activeClass="" id="fontSize" to="token" spy={true} smooth={true} duration={550}>TOKENOMICS</Link></div>

									<div class="connect2">
										<button class="wallet2">INTEGRATIONS <img src={arrow} /></button>
									</div>

								</div>

							</div>

						</div>

					</div>
				</Element>

				{_navbarOpen < 1 ?
					(<div class="miniBarMain">
						<div class="logo"><img class="logoPic" src={logo} /></div>

						<div class="navbarMain"><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
					</div>) :
					(<div class="miniBarMain">
						<div class="logo"><img class="logoPic" src={logo} /></div>

						<div class="navbarMain"><img class="navbar" onClick={closeNav} src={wrong} /></div>
					</div>)}

				{_navbarOpen > 0 ?
					(<div class="littleNav">
						<div ><Link activeClass="" id="fontSize" to="exchanges" spy={true} smooth={true} duration={550}>EXCHANGES</Link></div>
						<div ><Link activeClass="" id="fontSize" to="utils" spy={true} smooth={true} duration={550}>UTILITIES</Link></div>
						<div ><Link activeClass="" id="fontSize" to="buy" spy={true} smooth={true} duration={550}>HOW TO BUY</Link></div>
						<div ><Link activeClass="" id="fontSize" to="token" spy={true} smooth={true} duration={550}>TOKENOMICS</Link></div>

						<div class="connect2">
							<button class="wallet2">INTEGRATIONS <img src={arrow} /></button>
						</div>

					</div>) : null}
*/}

				<div class="cont">

					<div class="introduction">

						<div class="nftPicDiv">
							<img src={doggy} />
						</div>

						<div class="in2">
							<div class="intro">
								<img src={name} />
							</div>

							<div class="intro2">
								More than just a memecoin. Something big is coming..
							</div>
							<Link activeClass="" id="fontSize" to="exchanges" spy={true} smooth={true} duration={550}>
								<button className='explore'>EXPLORE</button>
							</Link>
						</div>

					</div>

					<div className='upLine'>
						<div className='upSocial'>
							<img onClick={tweet} src={twitter} />
						</div>

						<div className='boomGifDiv'><img className='airdrop' src={airdrop} /></div>
					</div>


				</div>

				<Ticker />

				{/*<Element name="exchanges">
					<Exchanges />
				</Element>

				<Element name="utils">
					<About />
				</Element>

				<Element name="buy">
					<Buy />
				</Element>

				<Element name="token">
					<Tokenomics />
				</Element>

				<Ticker />
*/}
			</div >

			{/*<Footer />
			{showButton ?
				<Link to="up" id="sticky-button" spy={true} smooth={true} duration={550}><div className='stickyMain'><img class="stickyBtn2" src={up} /></div></Link>
				: null}*/}

		</div >
	)
}

export default Home;